import { createReducer, on } from '@ngrx/store';

import * as fromOrdersModuleModels from '../../../orders/models';
import { CustomerOrdersActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromOrdersModuleModels.Order };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(CustomerOrdersActions.ReadCustomerOrders, state => {
    return {
      ...state,
      loading: true
    };
  }),
  on(CustomerOrdersActions.ReadCustomerOrdersSuccess, (state, { response }) => {
    const items = response['hydra:member'];
    const entities = items.reduce(
      (entities: { [iri: string]: fromOrdersModuleModels.Order }, item) => {
        return {
          ...entities,
          [item['@id']]: item
        };
      },
      { ...state.entities }
    );

    return {
      ...state,
      entities,
      errors: {},
      loaded: true,
      loading: false
    };
  }),
  on(
    CustomerOrdersActions.ReadCustomerOrdersFail,
    (state, { type, response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(CustomerOrdersActions.ResetCustomerOrdersState, state => {
    return {
      ...initialState
    };
  }),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
